import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { IUserSession, ConfigHelper, UserSession } from '../../helpers'
import { OpOperator } from '../../models/core'
import { Activity } from '../../models/common'

import { CashierPanelController, CashierPanelScope } from './cashier-panel.controller'

import { SERVICES_MODULE_NAME } from './../../services'
import { GridService, GRID_SERVICE_NAME } from '../../services/grid'

import {
    CASHIER_PANEL_SERVICE_NAME,
    CASHIER_PANEL_LOCATION_DETAILS_SERVICE_NAME,
    CashierPanelService,
    CashierPanelLocationDetailsService
} from './services'

import {
    CASHIER_PANEL_LOCATION_DETAILS_COMPONENT_NAME,
    CASHIER_PANEL_NEW_PAYMENT_POPUP_COMPONENT_NAME,
    CASHIER_PANEL_SEND_NOTIFICATION_COMPONENT_NAME,
    IMRCashierPanelLocatonDetailsComponent,
    IMRCashierPanelNewPaymentPopupComponent,
    IMRCashierPanelSendNotificationComponent
} from './components'
import { StateService, StateProvider } from '@uirouter/angularjs'

//#region Asset Imports

import './cashier-panel.scss'
import * as TEMPLATE from './cashier-panel.tpl.html'

//#endregion


// Consts

const CONTROLLER_NAME: string = 'CashierPanelController'
const MENU_INDEX = 6
const MODULE_NAME: string = 'simax.cashier-panel'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'CASHIER_PANEL_NAME'
const STATE_NAME: string = 'cashier-panel'
const STATE_URL: string = '/cashier-panel'

// Consts End


// Module Setup

const module: ng.IModule = angular.module(MODULE_NAME, [SERVICES_MODULE_NAME])

module.component(CASHIER_PANEL_LOCATION_DETAILS_COMPONENT_NAME, new IMRCashierPanelLocatonDetailsComponent())
module.component(CASHIER_PANEL_NEW_PAYMENT_POPUP_COMPONENT_NAME, new IMRCashierPanelNewPaymentPopupComponent())
module.component(CASHIER_PANEL_SEND_NOTIFICATION_COMPONENT_NAME, new IMRCashierPanelSendNotificationComponent())

module.service(CASHIER_PANEL_SERVICE_NAME, ['userSession', CashierPanelService])
module.service(CASHIER_PANEL_LOCATION_DETAILS_SERVICE_NAME, [CashierPanelLocationDetailsService])

module.controller(CONTROLLER_NAME, [
    '$scope',
    'userSession',
    '$stateParams',
    GRID_SERVICE_NAME,
    CASHIER_PANEL_SERVICE_NAME, (
        $scope: CashierPanelScope,
        userSession: IUserSession,
        $stateParams: StateService,
        gridService: GridService,
        cashierPanelService: CashierPanelService
    ) => new CashierPanelController($scope, userSession, $stateParams, gridService, cashierPanelService)
])

module.config(['$stateProvider', 'userSessionProvider', ($stateProvider: StateProvider, userSessionProvider: UserSession) => {
    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.CASHIER_PANEL_VIEW)) {
                setRouting($stateProvider)
                setMenuItem()
            }
        })
}])

// Module Setup End


// Routes Setup

function setRouting($stateProvider: StateProvider): void {
    $stateProvider.state(STATE_NAME, {
        url: STATE_URL,
        controller: CONTROLLER_NAME,
        template: TEMPLATE,
        params: { ids: null }
    })
}

// Routes Setup End


// Menu Setup

function setMenuItem(): void {
    MenuItem.addMenuItem(
        ConfigHelper.getIconName(ConfigHelper.Icon.DOLLAR),
        'cashier-panel',
        MODULE_NAME_LOCALIZATION_TEXT,
        STATE_NAME,
        MENU_INDEX
    )
}

// Menu Setup End


export default MODULE_NAME